/** One persisted preference shared by the root bootstrap and the existing Zustand store. */
export const THEME_STORAGE_KEY = 'dashboard-theme';
export const THEME_INIT_SCRIPT = `(function(){var dark=false;try{dark=localStorage.getItem('${THEME_STORAGE_KEY}')==='dark'}catch(e){}document.documentElement.classList.toggle('dark',dark)})();`;

export function applyTheme(dark: boolean, persist = true): void {
  if (typeof document === 'undefined') return;
  document.documentElement.classList.toggle('dark', dark);
  if (persist) {
    try { localStorage.setItem(THEME_STORAGE_KEY, dark ? 'dark' : 'light'); } catch { /* Storage may be disabled. */ }
  }
}
